'use client';

import React from 'react';
import Spinner from '@/components/platform/ui/Spinner';

interface AnimatedBorderButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
}

export default function AnimatedBorderButton({
  children,
  onClick,
  className = '',
  loading = false,
  disabled = false,
}: AnimatedBorderButtonProps) {
  return (
    <>
      <div
        className={`animated-wrapper ${className} ${loading || disabled ? 'cursor-not-allowed opacity-60' : ''}`}
      >
        <div
          className="animated-content inline-flex items-center justify-center gap-2 text-white"
          onClick={!loading && !disabled ? onClick : undefined}
        >
          {loading ? (
            <>
              <Spinner size="sm" darkMode={true} />
              <span>Loading...</span>
            </>
          ) : (
            children
          )}
        </div>
      </div>
      <style jsx>{`
        @property --angle {
          syntax: '<angle>';
          initial-value: 0deg;
          inherits: false;
        }

        .animated-wrapper {
          position: relative;
          width: fit-content;
          padding: 1px;
          border-radius: 7px;
          margin: 0 auto;
        }

        .animated-wrapper::after,
        .animated-wrapper::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image: conic-gradient(from var(--angle), #3b82f6, #10b981, #a855f7, #3b82f6);
          border-radius: 7px;
          animation: 3s spin linear infinite;
        }

        .animated-wrapper::before {
          filter: blur(1.5rem);
          opacity: 0.5;
        }

        .animated-content {
          position: relative;
          padding: 0.5rem 0.75rem;
          background: #1c1f2b;
          text-align: center;
          border-radius: 7px;
          cursor: pointer;
          z-index: 1;
        }

        @keyframes spin {
          from {
            --angle: 0deg;
          }
          to {
            --angle: 360deg;
          }
        }
      `}</style>
    </>
  );
}
